import React from 'react';

const BudgetIcon = ({ fill, className }) => {
  return (
    <svg
      width='20'
      height='21'
      viewBox='0 0 20 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M0.545455 7.02711L9.63636 11.6636C9.72727 11.7563 9.81818 11.7563 10 11.7563C10.1818 11.7563 10.2727 11.7563 10.3636 11.6636L19.4545 7.02711C19.8182 6.84165 20 6.56346 20 6.19254C20 5.82162 19.8182 5.54343 19.4545 5.35797L10.3636 0.721464C10.0909 0.628734 9.81818 0.628734 9.54545 0.721464L0.454545 5.35797C0.181818 5.54343 0 5.82162 0 6.19254C0 6.56346 0.181818 6.84165 0.545455 7.02711ZM10 2.6709L17 6.20413L10 9.73736L3 6.20413L10 2.6709ZM19.9284 15.2569C20.1109 15.6932 19.9284 16.2168 19.5634 16.3913L10.4391 20.7545C10.2566 20.8418 10.1654 20.8418 9.98289 20.8418C9.8004 20.8418 9.70916 20.8418 9.61792 20.7545L0.493584 16.3913C0.0373678 16.2168 -0.145119 15.6932 0.128611 15.2569C0.311098 14.8206 0.858558 14.646 1.31477 14.9078L10.0741 19.0965L18.8335 14.9078C19.1072 14.646 19.6547 14.8206 19.9284 15.2569ZM19.9284 10.2094C20.1109 10.6457 19.9284 11.1693 19.5634 11.3439L10.4391 15.7071C10.2566 15.7943 10.1654 15.7943 9.98289 15.7943C9.8004 15.7943 9.70916 15.7943 9.61792 15.7071L0.493584 11.3439C0.0373678 11.1693 -0.145119 10.6457 0.128611 10.2094C0.311098 9.7731 0.858558 9.59857 1.31477 9.86036L10.0741 14.049L18.8335 9.86036C19.1072 9.59857 19.6547 9.7731 19.9284 10.2094Z'
        fill={fill}
      />
    </svg>
  );
};

export default BudgetIcon;
